import { useSelector } from "react-redux";
import { getMetadata } from "@/features/metadata/metadataSlice";
import { WEB_PRODUCER_CODES } from "@/config/constants";
import { getRenewalDetailsDataSelector } from "@/features/quote/quoteSlice";

const EBIZ_PRODUCER_CODES = new Set(WEB_PRODUCER_CODES);

export const useAssistanceNumber = () => {
  const metadata = useSelector(getMetadata);
  const renewalDetailsData = useSelector(getRenewalDetailsDataSelector);

  const appName = metadata?.appName?.toUpperCase()?.trim();
  const producerRole = metadata?.producerRole?.toLowerCase()?.trim();
  const producerCode = renewalDetailsData?.producerCode;
  const isRetentionUser = (appName === "IPDS" && producerRole === "customersupportretention");

  const isEbizUser =
    (appName === "CUSTOMER_WEB" || isRetentionUser) && EBIZ_PRODUCER_CODES.has(producerCode);

  return isEbizUser ? "022-69753012" : "18002667780";
};
